import { z } from "zod";

import { AudienceFiltersDtoSchema } from "../../../../../dtos/audiences";

export const PluginAudienceFiltersSchema_2024_05_05 =
  AudienceFiltersDtoSchema.omit({
    id: true,
  });

export type PluginAudienceFiltersType_2024_05_05 = z.infer<
  typeof PluginAudienceFiltersSchema_2024_05_05
>;
